export default __webpack_public_path__ + "static/media/s5-img.baff7717.png";